import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import AddonList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import {ADD_STATE, REMOVE_STATE, setApp, setUdn, setUserIsAdmin} from "../../../redux/actions/generics/IndexedActions";

const Addon = props => {
    const path = props.path || 'sales/addon';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

    },[]);

    return <>
        {loading && showLoader()}
        { componentState && <AddonList path={path} /> }
    </>
}

const mapStateToProps = state => ({ })
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin
})

export default connect(mapStateToProps, mapActionsToProps)(Addon)
